import { ConfigurationState } from '../types/configuration'

export const configurationInitialState: ConfigurationState = {
  files: [],
  formData: null,
  loading: false,
  error: null,
}
